<div class="fdf" data-testid="destination-port-filter">
  <div class="fdf-row">
    <app-searchable-select
      class="fdf-destination"
      testId="destination-port-select"
      [label]="'proposals.dialogs.freightFilter.destinationPort' | transloco"
      [placeholder]="'proposals.dialogs.freightFilter.destinationPlaceholder' | transloco"
      [allLabel]="'proposals.dialogs.freightFilter.all' | transloco"
      [options]="selectOptions"
      [value]="value"
      [disabled]="!options.length"
      (valueChange)="valueChange.emit($any($event))"></app-searchable-select>

    <mat-form-field class="fdf-search fuse-mat-dense" subscriptSizing="dynamic">
      <mat-label>{{ 'proposals.dialogs.freightFilter.searchLabel' | transloco }}</mat-label>
      <input
        matInput
        type="search"
        autocomplete="off"
        data-testid="freight-search"
        [placeholder]="'proposals.dialogs.freightFilter.searchPlaceholder' | transloco"
        (input)="searchChange.emit($any($event.target).value)" />
    </mat-form-field>
  </div>

  <p *ngIf="!options.length" class="fdf-note" data-testid="destination-port-empty">
    {{ 'proposals.dialogs.freightFilter.noPorts' | transloco }}
  </p>
  <p *ngIf="moreFreights" class="fdf-note fdf-note-warn" data-testid="more-freights-hint" role="status">
    {{ 'proposals.dialogs.freightFilter.moreFreights' | transloco }}
  </p>
</div>
